import React from 'react';
const DownArrow = ({
  color = 'currentColor',
  className,
}: {
  color?: string;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="5"
      viewBox="0 0 6 5"
      fill="none"
      className={className}>
      <path
        d="M2.20759 3.97063C2.6079 4.49064 3.3921 4.49064 3.79241 3.97063L5.22473 2.10999C5.73092 1.45243 5.26216 0.5 4.43232 0.5H1.56768C0.737838 0.5 0.269076 1.45243 0.775273 2.10999L2.20759 3.97063Z"
        fill={color}
      />
    </svg>
  );
};

export default DownArrow;
